// import { isImgUrl } from "@/lib/image-providers";
// import { cn } from "@/lib/utils";
import { ImageOrLink } from "@/components/blocks/image-or-link";
import { ExternalLink, Play } from "lucide-react";
import { Button } from "@/components/ui/button";
import { VideoInfo } from "@/components/blocks/video-player";
import { getYoutubeVideoInfo } from "@/lib/youtube-utils";
import { ImageWithFallback } from "@/components/blocks/image-with-fallback";

export function MessageRenderer({
  message,
  onPlayVideo,
}: {
  message: string;
  onPlayVideo?: (info: VideoInfo) => void;
}) {
  const renderMessage = (message: string) => {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    const parts = message.split(urlRegex);
    return (
      <div className="w-full whitespace-pre-wrap">
        {parts.map((part, index) => {
          if (part.match(urlRegex)) {
            // if (part.match(/\.(jpg|jpeg|png|gif)$/i)) {
            //   return (
            //     <img
            //       key={index}
            //       src={part}
            //       loading="lazy"
            //       alt="Shared image"
            //       className="
            //       w-full
            //       h-auto
            //       max-h-[70vh]
            //       object-contain rounded-lg my-2"
            //     />
            //   );
            // } else
            if (part.match(/\.(gif)$/i)) {
              return (
                <img
                  key={index}
                  src={part}
                  loading="lazy"
                  alt="Shared image"
                  className="
                  max-w-[250px]
                  object-contain rounded-lg my-2"
                />
              );
            } else if (
              part.includes("youtube.com") ||
              part.includes("youtu.be")
            ) {
              const youtubeInfo = getYoutubeVideoInfo(part);
              if (youtubeInfo) {
                const thumbnailStyle = youtubeInfo.isShorts
                  ? "w-full max-w-[250px] h-auto object-contain"
                  : "w-full max-w-[400px] h-auto object-contain";
                return (
                  <div key={index} className="relative w-fit">
                    <ImageWithFallback
                      src={youtubeInfo.thumbnailUrl.url}
                      fallbackSrc={youtubeInfo.thumbnailUrl.fallbackUrl}
                      alt="YouTube Thumbnail"
                      className={thumbnailStyle}
                    />
                    <div
                      className="absolute
                      w-[52px] h-[36px]
                      top-1/2 left-1/2 
                      -translate-x-1/2 -translate-y-1/2"
                    >
                      <Button
                        variant="red"
                        onClick={() => onPlayVideo?.(youtubeInfo)}
                      >
                        <Play />
                      </Button>
                    </div>
                    <div className="absolute top-0 right-0 p-2">
                      <a
                        key={index}
                        href={part}
                        target="_blank"
                        rel="noreferrer"
                        className="text-blue-500 hover:underline"
                      >
                        <ExternalLink />
                      </a>
                    </div>
                  </div>
                );
              } else {
                return (
                  <a
                    key={index}
                    href={part}
                    target="_blank"
                    rel="noreferrer"
                    className="text-blue-500 hover:underline"
                  >
                    {part}
                  </a>
                );
              }
            } else {
              return (
                <ImageOrLink
                  key={index}
                  url={part}
                  lazyLoad={true}
                  imgClassName="
                  w-full 
                  h-auto 
                  max-h-[70vh] 
                  object-contain rounded-lg my-2"
                  linkClassName="text-blue-500 hover:underline"
                />
              );
            }
          } else {
            return <span key={index}>{part}</span>;
          }
        })}
      </div>
    );
  };

  return renderMessage(message);
}
